import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { EditableQuestion } from '../../../../../types';
import { StyledQuestionFieldContainer } from '../styles';
import Switch from '../../../../../../Shared/Switch';

interface Props {
  control: Control<EditableQuestion>;
}

const PhaseEditor = ({ control }: Props) => (
  <Controller
    control={control}
    name="phase"
    render={({ field: { value, onChange } }) => (
      <StyledQuestionFieldContainer>
        <Switch
          label="Asked after ordering"
          value="post_order"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            onChange(event.target.checked ? 'post_order' : 'pre_order')
          }
          checked={value === 'post_order'}
          disabled={false}
          reverseOrder={false}
        />
      </StyledQuestionFieldContainer>
    )}
  />
);

export default PhaseEditor;
